module.exports = __webpack_public_path__ + "static/img/hb_5-min.6358b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_5-min.png
// module id = /ATk
// module chunks = 1